import * as _ from "lodash";
import * as React from "react";
import { Dropdown } from "react-bootstrap";
import * as ReactDOM from "react-dom";
export class DummyMenu extends React.Component {
    static defaultProps = {
        bsRole: Dropdown.Menu.defaultProps.bsRole,
    };
    render() {
        return React.createElement("div", null);
    }
    focusNext() {
        // nop
    }
}
/**
 * An enhanced dropdown that adjusts placement of the popover based on the
 * position within the container, so it doesn't get cut off (as long as the
 * popover isn't larger than half of the container)
 *
 * @class MyDropdown
 * @extends {React.Component<IProps, { up: boolean }>}
 */
class MyDropdown extends React.Component {
    static Menu = Dropdown.Menu;
    static Toggle = Dropdown.Toggle;
    mNode;
    mOpen = false;
    constructor(props) {
        super(props);
        this.state = {
            up: false,
        };
    }
    componentDidMount() {
        this.mNode = ReactDOM.findDOMNode(this);
    }
    render() {
        const relayProps = _.omit(this.props, [
            "container",
            "dropup",
            "onToggle",
            "children",
        ]);
        const filt = this.mOpen
            ? this.props.children
            : React.Children.map(this.props.children, (child) => child.props.bsRole === "menu" ? React.createElement(DummyMenu, null) : child);
        return (React.createElement(Dropdown, { dropup: this.state.up, onToggle: this.onToggle, ...relayProps }, filt));
    }
    get bounds() {
        return this.props.container
            ? this.props.container.getBoundingClientRect()
            : {
                top: 0,
                left: 0,
                bottom: window.innerHeight,
                right: window.innerWidth,
                height: window.innerHeight,
                width: window.innerWidth,
            };
    }
    onToggle = (isOpen) => {
        this.mOpen = isOpen;
        if (isOpen) {
            const bounds = this.bounds;
            const newUp = this.mNode.getBoundingClientRect().bottom >
                bounds.top + bounds.height / 2;
            // force redraw to ensure the menu gets rendered too
            this.setState({ up: newUp });
        }
        if (this.props.onToggle) {
            this.props.onToggle.apply(this, [isOpen]);
        }
    };
}
export default MyDropdown;
